/**
 * Text Processing Utilities
 * Handles text transformations for database content displayed in the reader
 */

/**
 * Convert line breaks in database content to HTML
 * - Double line breaks (\n\n) become paragraph breaks (&nbsp;<br>)
 * - Single line breaks (\n) become line breaks (<br>)
 *
 * @param {string} content - Raw content from database
 * @returns {string} - Content with HTML line breaks
 */
export function convertLineBreaks(content) {
  if (!content || typeof content !== 'string') {
    return content;
  }

  // First, normalize line endings (handle \r\n and \r)
  let normalized = content.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  // Convert double line breaks to paragraph breaks
  normalized = normalized.replace(/\n\n/g, '&nbsp;<br>');

  // Convert remaining single line breaks
  normalized = normalized.replace(/\n/g, '<br>');

  return normalized;
}
